let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("k25cY")).then(() => parcelRequire('jzYEO'));